// extracted by mini-css-extract-plugin
module.exports = {"threeDViewBanner":"JwWLY","threeDViewBannerLeft":"bYnhD","threeDViewBannerRight":"lYmcV","arrowIcon":"mjMOo"};